// Feature Flags for Editor System
export const featureFlags = {
  // Selection and Hit-Test improvements  
  ff_editor_click_priority: true, // منطق أولوية النقر
  ff_editor_click_select_priority: true,
  ff_editor_dropzone_clean: true,
  
  // DnD improvements
  ff_editor_dnd_single_provider: true, // مزود DnD وحيد
  ff_editor_enhanced_dnd: true,
  ff_editor_improved_sensors: true,
  
  // Debug and diagnostics
  ff_editor_debug: true, // Set to true to enable debug overlay
  ff_editor_debug_hud: false, // طبقة تشخيص
  
  // UI improvements  
  ff_editor_cursor_fix: true,
  ff_editor_toolbar_positioning: true,
  
  // Performance improvements
  ff_editor_optimized_rendering: true,
  ff_editor_batch_updates: true,
  
  // ✅ NEW: Dynamic Pages Runtime System (ENABLED - نظام موحد)
  ff_dynamic_pages_runtime: true,   // تفعيل العرض الديناميكي - النظام الموحد
  ff_sections_runtime: true,        // قالب السكشنات
  ff_normal_runtime: true,          // قالب الصفحات العادية
  ff_menu_from_db: true,            // جلب القوائم من DB
  
  // ✅ Phase 2: Individual Runtime Controls
  ff_dynamic_sections_runtime: true,  // تحكم منفصل بعرض السكشنات
  ff_dynamic_normal_runtime: true,    // تحكم منفصل بعرض الصفحات العادية
  ff_runtime_debug: false,            // سجلات تشخيص للـ runtime
  ff_header_auto_theme: true,         // عكس ألوان الهيدر التلقائي
  
  // ✅ Editor cleanup
  ff_editor_single_canvas: true,   // محرر موحد بدون تكرار
  
  // ✅ Dynamic Components Styling System  
  ff_dynamic_components_style: true,   // نظام تصميم المكونات الديناميكية مفعل
  ff_dynamic_advanced_elements: true,  // العناصر الديناميكية المتقدمة
  
  // Carousel & accessibility enhancements
  ff_carousel_autoplay: false,         // تفعيل التشغيل التلقائي للكاروسيل
  ff_accessibility_enhancements: true, // تحسينات الوصول (ARIA, focus management)
  // Layout system (next-gen flexible sections)
  ff_layout_sections: true,          // تفعيل سكشن تخطيط مرن (مفعل للتجربة)
  ff_layout_editor: true,            // واجهة تحرير التخطيط المرن (مفعلة)
  
  // Navigation overflow restoration
  ff_nav_overflow_menu: true,        // تفعيل نظام إخفاء عناصر التنقل في زر المزيد عند ضيق المساحة

  // Admin RTL overhaul (مرحلي) - يعزل تحسينات RTL الجديدة خلف علم حتى تثبت
  ff_admin_rtl_overhaul: true,
  // Internal Pages Manager (Phase A scaffold)
  ff_internal_pages_manager: true,
  ff_internal_pages_meta: true,              // محرر ميتا
  ff_internal_pages_background: true,        // محرر خلفية الهيرو
  ff_internal_pages_draft: true,             // دعم المسودات
  ff_internal_pages_runtime_integration: true, // دمج في الواجهة العامة
  ff_internal_pages_localization_util: true, // تفعيل getLocalized
  ff_internal_pages_validation: true,        // رسائل التحقق المتقدمة
  ff_internal_pages_diff_modal: true,        // عرض نافذة مقارنة التعديلات
  ff_internal_pages_schedule: true,          // جدولة النشر للمسودات
  ff_internal_pages_diff_enhanced: true,     // تحسينات واجهة المقارنة (بحث/تصفية/تصدير)
  ff_internal_pages_auto_scheduler: true,    // تفعيل تنفيذ المجدول الآلي (Edge function + cron)
  ff_internal_pages_manager_enhanced: true,  // واجهة تحكم موسعة (بحث، إنشاء، استنساخ، نشر جماعي)
  ff_internal_pages_autosave: true,          // حفظ مسودة تلقائي
  ff_internal_pages_seed: true,              // تهيئة الصفحات الافتراضية (زر seed)
  ff_internal_pages_enrich: true,            // ملء المحتوى المقترح (نصوص/أوصاف/خلفيات)
};

export const isFeatureEnabled = (flag: keyof typeof featureFlags): boolean => {
  return featureFlags[flag] === true;
};

export const enableFeature = (flag: keyof typeof featureFlags) => {
  featureFlags[flag] = true;
  console.log(`🚩 Feature enabled: ${flag}`);
};

export const disableFeature = (flag: keyof typeof featureFlags) => {
  featureFlags[flag] = false;
  console.log(`🚩 Feature disabled: ${flag}`);
};

export const forcePageRefresh = () => {
  console.log('🔄 إعادة تحديث يدوية للصفحة (النظام القديم المستعاد)');
  window.dispatchEvent(new CustomEvent('pageDataUpdated', {
    detail: { forced: true, timestamp: Date.now(), system: 'legacy' }
  }));
};

// Debug helper
export const toggleDebugMode = () => {
  featureFlags.ff_editor_debug = !featureFlags.ff_editor_debug;
  console.log(`🐛 Debug mode: ${featureFlags.ff_editor_debug ? 'ON' : 'OFF'}`);
  return featureFlags.ff_editor_debug;
};

// URL param overrides (evaluated at module load so router picks it up)
const getQueryFlag = (name: string): boolean => {
  try {
    const url = new URL(window.location.href);
    const v = url.searchParams.get(name);
    return v === '1' || v === 'true' || v === 'on';
  } catch {
    return false;
  }
};

try {
  if (getQueryFlag('dynamic') || getQueryFlag('dyn')) {
    featureFlags.ff_dynamic_pages_runtime = true;
    console.info('🚩 URL override: ff_dynamic_pages_runtime = true');
  }
  if (getQueryFlag('sections')) {
    featureFlags.ff_sections_runtime = true;
    console.info('🚩 URL override: ff_sections_runtime = true');
  }
} catch { /* noop */ }

export const isRtlOverhaulEnabled = () => featureFlags.ff_admin_rtl_overhaul === true;